import React, { useState, useEffect, useContext, useRef } from "react";
import { Link } from "react-router-dom";
import ItemNew from './../components/ItemNew';
import LoaderContext from './../components/LoaderContext';
import LoginPage from './LoginPage';
import { buildEntreeTagColumns, tagArray } from '../utils/helpers';
import MenuBar from "../components/Menubar";
import { useCravings } from '../hooks/useCravings';

type Props = {
	name: String;
	id: Number;
	eatOrMeal: String;
	location: any;
	user: any;
	handleLogin(user): void;
};

const EatYolosPage: React.FC<Props> = (props) => {
	const ref = useRef<HTMLDivElement | null>(null);
	const [error, setError] = useState('');
	const [nearByItems, setNearByItems] = useState<any[]>([]);
	const [topItems, setTopItems] = useState<any[]>([]);
	const [tags, setTags] = useState<number[]>([]);
	const [showFilter, setShowFilter] = useState(false);
	const [showLogin, setShowLogin] = useState(false);
    // craving update: state to show login prompt when logged-out user clicks heart
    const [showCravingPrompt, setShowCravingPrompt] = useState(false);
	const { showLoader, hideLoader } = useContext(LoaderContext);
	const [showJumpToTopButton, setShowJumpToTopButton] = useState(false);
	const { cravedIds, handleToggleCraving } = useCravings(props.user);

	const handleScrolBottomToTop = () => {
		const windowHeight = window.innerHeight; // Height of the viewport
		const scrollPosition = window.scrollY; // Current scroll position
		const scrollThreshold = windowHeight * 1; // Threshold at 25% down the page
	
		setShowJumpToTopButton(scrollPosition > scrollThreshold); // Show button when scrolled past 25% down
	};

	const handleJumpToTop = () => {
		window.scrollTo({ top: 0, behavior: 'smooth' }); // Scroll to top of the page smoothly
	};

	useEffect(() => {
		window.addEventListener('scroll', handleScrolBottomToTop);
		return () => window.removeEventListener('scroll', handleScrolBottomToTop);
	}, []);

	useEffect(() => {
		loadItems(tags);
	}, [props.user.isLogged]);



	const log = async (message: any) => {
		if (process.env.REACT_APP_LOG === 'true') console.log(message);
	};

	const syncUpvoteCount = (id: number, upvoteCount: number) => {
		setNearByItems(prev => prev.map(item => item.id === id ? { ...item, upvoteCount } : item));
		setTopItems(prev => prev.map(item => item.id === id ? { ...item, upvoteCount } : item));
	};

	const handleUpvote = async (id: number) => {
		showLoader();
		const data = { userId: (props.user as any).id };
		fetch(process.env.REACT_APP_SERVER_URL + "/items/" + id + "/upvote", {
			method: 'POST',
			headers: new Headers({
				'Content-Type': 'application/json',
				"Accept": "application/json",
				'Authorization': 'Bearer ' + (props.user as any).token
			}),
			body: JSON.stringify(data)
		})
			.then(res => res.json())
			.then(
				(result) => {
					log(result);
					setNearByItems(prev => prev.map(item => item.id === id ? { ...item, upvoted: true, upvoteCount: item.upvoteCount + 1 } : item));
					setTopItems(prev => prev.map(item => item.id === id ? { ...item, upvoted: true, upvoteCount: item.upvoteCount + 1 } : item));
					setError("");
					hideLoader();
				},
				(error) => {
					log(error);
					setError(error.message);
					hideLoader();
				}
			);
	};

	const RemoveUpvote = async (id: number) => {
		showLoader();
		const data = { userId: (props.user as any).id };
		fetch(process.env.REACT_APP_SERVER_URL + "/items/" + id + "/removeUpvote", {
			method: 'DELETE',
			headers: new Headers({
				'Content-Type': 'application/json',
				"Accept": "application/json",
				'Authorization': 'Bearer ' + (props.user as any).token
			}),
			body: JSON.stringify(data)
		})
			.then(res => res.json())
			.then(
				(result) => {
					log(result);
					setNearByItems(prev => prev.map(item => item.id === id ? { ...item, upvoted: false, upvoteCount: item.upvoteCount - 1 } : item));
					setTopItems(prev => prev.map(item => item.id === id ? { ...item, upvoted: false, upvoteCount: item.upvoteCount - 1 } : item));
					setError("");
					hideLoader();
				},
				(error) => {
					log(error);
					setError(error.message);
					hideLoader();
				}
			);
	};


	const onTagClick = (id: number) => {
		const applying = !tags.includes(id);

		let newTags: number[];
		if (tags.includes(id)) {
			newTags = tags.filter(tag => tag !== id);
		} else {
			newTags = [...tags, id];
			if (ref.current) {
				window.scrollTo({ top: (ref.current as any).offsetTop, behavior: "smooth" });
			}
		}
		setTags(newTags);
		loadItems(newTags);

		if (applying && (props.user as any)?.isLogged) {
			fetch(`${process.env.REACT_APP_SERVER_URL}/action/food-filter/${(props.user as any).id}`, {
				method: 'POST',
				headers: new Headers({
					'Content-Type': 'application/json',
					'Accept': 'application/json',
					'Authorization': 'Bearer ' + (props.user as any).token
				}),
				body: JSON.stringify({
					filterKey: id,
					action: 'apply',
					timestamp: new Date().toISOString()
				})
			})
				.then(res => res.json())
				.then(r => log(r))
				.catch(err => log('filter-tap error'));
		}
	};

	const loadItems = (newTags: number[]) => {
		showLoader();

		const headers = new Headers({
			'Content-Type': 'application/json',
			'Accept': 'application/json'
		});
		if ((props.user as any).isLogged) {
			headers.append('Authorization', 'Bearer ' + (props.user as any).token);
		}

		const miles = Number(localStorage.getItem('selectedDistance'));
		fetch(
			process.env.REACT_APP_SERVER_URL +
			`/yolos?category=${props.id}&latitude=${props.location.lat}&longitude=${props.location.lng}&tags=${newTags.join()}&distanceMiles=${miles}&v=${Date.now()}`,
			{ method: 'GET', headers }
		)
			.then(res => res.json())
			.then(
				(result) => {
					log(result);
					setNearByItems(result.nearBy || []);
					setTopItems(result.top || []);
					setError("");
					hideLoader();
					setShowLogin(false);
				},
				(error) => {
					log(error);
					setError(error.message);
					hideLoader();
				}
			);
	};

	const onLoginClick = () => setShowLogin(true);
    const onLoginBackClick = () => setShowLogin(false);
    // craving update: show middle page when logged-out user clicks heart
    const handleLoginPrompt = () => setShowCravingPrompt(true);
    const onCravingPromptBackClick = () => setShowCravingPrompt(false);

	const handleNotificationClick = async (id: number) => {
		sendNotification(id);
	};

	const sendNotification = (id: number) => {
		try {
			const stored = localStorage.getItem('YoloMeal');
			console.log(stored);
			if (stored) {
				showLoader();
				const userData = JSON.parse(stored);
				fetch(
					process.env.REACT_APP_SERVER_URL + `/itemExpired?itemId=${id}&userId=${userData.id}`,
					{
						method: 'GET',
						headers: new Headers({
							'Content-Type': 'application/json',
							Accept: 'application/json',
							Authorization: 'Bearer ' + userData.token,
						})
					}
				)
					.then(
						() => {
							setNearByItems(prev => prev?.map((item) => (item.id === id ? { ...item, expired: true } : item)));
							setTopItems(prev => prev?.map((item) => (item.id === id ? { ...item, expired: true } : item)));
							hideLoader();
						},
						() => hideLoader()
					);

			}
		} catch (error) {
			console.error('Error fetching categories:', error);
		}
	};

	const loadData = () => loadItems(tags);

	const categoryId = Number(props.id);
	const allTags = tagArray.filter(el => el.category === categoryId);
	const totalTagsCount = allTags.length;

	let leftTags = allTags;
	let rightTags: typeof allTags = [];
	if (categoryId === 1) {
		const entreeColumns = buildEntreeTagColumns(allTags);
		leftTags = entreeColumns.types;
		rightTags = entreeColumns.nationalities;
	} else if (categoryId === 14) {
		// Fast Food: left 92–122, right 123–150
		leftTags = allTags.filter(t => t.id >= 92 && t.id <= 122);
		rightTags = allTags.filter(t => t.id >= 123 && t.id <= 151);
	} else {
		// Generic: split evenly into two columns
		const mid = Math.ceil(allTags.length / 2);
		leftTags = allTags.slice(0, mid);
		rightTags = allTags.slice(mid);
	}

	const renderTag = (tag: { id: number; name: string }) => {
		const checked = tags.includes(tag.id);
		return (
			<li className="tag-filter" key={tag.id}>
				<input
					type="checkbox"
					id={`tags${tag.id}`}
					onClick={() => onTagClick(tag.id)}
					checked={checked}
					readOnly
				/>
				<label htmlFor={`tags${tag.id}`}>{tag.name}</label>
			</li>
		);
	};

	const leftList = leftTags.map(renderTag);
	const rightList = rightTags.map(renderTag);

	let mainClass = "main-bg eat-bg ";
	let back = <Link to="/eat">Eat</Link>;
	let titleClass = "text-center pt-3 pb-2 uppercase";
	let helpClass = "f-38 light text-center font-poppins";
	if (props.eatOrMeal === 'drink') {
		mainClass = "main-bg drink-bg ";
		back = <Link to="/drinks">Drinks</Link>;
		titleClass = "text-center pt-3 pb-2 uppercase white";
		helpClass = helpClass + " white";
	}

	const handleMainFilter = (value: boolean) => setShowFilter(value);

// craving update: middle page for logged-out heart click
if (showCravingPrompt && !(props.user as any).isLogged) {
    return (
        <main className="main-bg">
            <div className="container mypage" style={{ width: '100%', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
                <MenuBar user={props.user} />
                <section style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <div className="page-box-main text-center" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 18 }}>
                        <h1 className="font-reklame" style={{ margin: 0 }}>
                            You must be signed in to save cravings
                        </h1>
                        <Link className="tap-to-upvote-btn upvote_btn pill-std" to="/login">
                            Log in
                        </Link>
                        <a className="tap-to-upvote-btn upvote_btn pill-std" style={{ cursor: 'pointer' }} onClick={onCravingPromptBackClick}>
                            Go back
                        </a>
                    </div>
                </section>
            </div>
        </main>
    );
}

if (showLogin && !(props.user as any).isLogged) {
    return (
      <LoginPage
        user={props.user}
        handleLogin={props.handleLogin}
        showBack={true}
        showHome={false}
        backgroundImage={true}
        handleBack={onLoginBackClick}
      />
    );
  }
  return (
    <main className={mainClass}>
      <div className="container">
        <MenuBar user={props.user} />
      </div>

      <div className="eat-main notification-settings" style={{ marginBottom: '90px' }}>
        <h1 className={titleClass}>{props.name}</h1>

        {totalTagsCount > 0 && !showFilter && (
          <div className="my-pagebox tag-filter-panel pink-button text-center" onClick={() => setShowFilter(true)}>
            Click here to filter your choices
          </div>
        )}

        {totalTagsCount > 0 && showFilter && (
          <div className="my-pagebox tag-filter-panel">
            <div className="checkbox-wrapper">
              <div className="checkbox-column">
                {categoryId === 1 && <h3 className="tag-column-heading">Types</h3>}
                <ul className="f-18 checkbox-list">{leftList}</ul>
              </div>
              <div className="checkbox-column">
                {categoryId === 1 && <h3 className="tag-column-heading">Nationalities</h3>}
                <ul className="f-18 checkbox-list">{rightList}</ul>
              </div>
            </div>
          </div>
        )}

        <div ref={ref} />

        {nearByItems.length === 0 && (
          <h3 className={helpClass}>Help everyone find the BEST by saving one of your TOP 3 here!</h3>
        )}

        <div className="categoryItem card-container">
          {nearByItems.map(
            (item) =>
              item.yolos?.length > 0 &&
              item.yolos[0].id !== null && (
                <div key={item.id} className="categoryItemWidth">
                  <ItemNew
                    handleLogin={onLoginClick}
                    item={item}
                    editable={(props.user as any).id == 6 || (props.user as any).id == 7 || (props.user as any).id == 514}
                    isLogged={(props.user as any).isLogged}
                    user={props.user}
										page={"eatYolosPage"}
                    showRestaurant={true}
                    handleUpvote={handleUpvote}
                    handleRemoveUpvote={RemoveUpvote}
                    handleNotificationClick={handleNotificationClick}
                    restaurentPage={false}
                    loadData={loadData}
                    syncUpvoteCount={syncUpvoteCount}
                    handleMainFilter={handleMainFilter}
                     craved={cravedIds.has(item.id)}
                     handleToggleCraving={handleToggleCraving}

                     handleLoginPrompt={handleLoginPrompt}
                  />
                </div>
              )
          )}
        </div>

        {nearByItems?.length === 0 && (
          <div>
            <div className="mt-4 white ">
              <h1 className="text-center pt-3 pb-2 uppercase add-favorite-btn">
                <Link to="/add-yolo">Add Favorite</Link>
              </h1>
            </div>
          </div>
        )}

        {topItems?.length > 0 && (
          <h3 className={helpClass}>
            You can be the first to help everyone find a great meal by saving you favorite here!
          </h3>
        )}

        {error !== '' && <p>{error}</p>}
      </div>
      {showJumpToTopButton && (
				<button className="jump-to-top-button" onClick={handleJumpToTop}>
					Jump to Top
				</button>
			)}
		</main>
	);
};

export default EatYolosPage;
